import React from 'react';

export default function SectionDivider() {
  return <div className="section-divider" role="presentation" aria-hidden="true" />;
}
